export const cardGroupList = [
  {
    title: '我的消息',
    iconUrl:
      'https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/ImagesupplierIcon1.png',
    url: `${process.env.YCX_HOME}/buyer/myNoticeList`,
  },
  {
    title: '商机收藏',
    iconUrl:
      'https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/ImagesupplierIcon1.png',
    url: `${process.env.YCX_HOME}/buyer/supplierCollection`,
  },
];
export const tabContentList = {
  // supplier: [
  //   {
  //     title: '找商机',
  //     iconUrl:
  //       'https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/ImagesupplierIcon1.png',
  //     successPath: `${process.env.QCS_URL}/crm/index_html/sourcing/sourcing_supplier_opportunity_market_new`,
  //     failPath: '/portal/opportunities',
  //     type: 'business',
  //   },
  //   {
  //     title: '找标讯',
  //     iconUrl:
  //       'https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/ImagesupplierIco2.png',
  //     successPath: `${process.env.QCS_URL}/crm/index_html/sourcing/crm_tenders_info_market`,
  //     failPath: '/portal/tenders',
  //     type: 'signal',
  //   },
  //   {
  //     title: '找企业',
  //     iconUrl:
  //       'https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/ImagesupplierIcon3.png',
  //     successPath: `${process.env.QCS_URL}/crm/index_html/sourcing/sourcing_supplier_company_plaza_new`,
  //     failPath: '/portal/enterprises',
  //     type: 'company',
  //   },
  // ],
  purchasingAgent: [
    {
      title: '寻源',
      iconUrl:
        'https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/purchaseList.png',
      successPath: `${process.env.BUYER_WEB}/page/iframe.htm?menuCode=sourcing_purchase_list&`,
      failPath:
        'https://www.xxxxxx.com/product/applicationservice/alicloudproc-srm',
    },
    {
      title: '订单',
      iconUrl:
        'https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/bStatisticsDashboard.png',
      successPath: `${process.env.BUYER_WEB}/page/iframe.htm?menuCode=cg_b_order_list&`,
      failPath:
        'https://www.xxxxxx.com/product/applicationservice/alicloudproc-srm',
    },
    {
      title: '供应商',
      iconUrl:
        'https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/supplier-manage2.png',
      successPath: `${process.env.BUYER_WEB}/page/iframe.htm?menuCode=enterprise_supplier_list&`,
      failPath:
        'https://www.xxxxxx.com/product/applicationservice/alicloudproc-srm',
    },
  ],
};
